
import {
  IonButton,
  IonCol,
  IonGrid,
  IonLabel,
  IonItem,
  IonText,
  IonList,
  IonRow,
  modalController
} from "@ionic/vue";
import {
  saveOutline,
  lockOpenOutline,
  lockClosedOutline,
} from "ionicons/icons";

import { defineComponent, reactive, ref } from "vue";
import PaymentCardIcon from "./CardIcon.vue";
import UpdateBillingModal from "./UpdateBillingModal.vue";

export default defineComponent({
  name: "BillingDetails",
  props: {
    initFormData: {
      type: Object,
      default: null,
    },
  },
  components: {
    IonButton,
    IonCol,
    IonGrid,
    IonItem,
    // IonLabel,
    IonList,
    IonRow,
    // IonText,
    PaymentCardIcon,
  },
  setup(props: any) {
    const loaded = ref(false);
    const submitting = ref(false);
    const success = ref(false);
    const errorTxt = ref("");
    const edit = ref(false);
    const formData = reactive(Object.assign({}, props.initFormData));
    let t: any;
    return {
      formData,
      t,
      loaded,
      submitting,
      success,
      errorTxt,
      edit,
      saveOutline,
      lockOpenOutline,
      lockClosedOutline,
    };
  },
  computed: {
    selectedCounty(): any {
      return this.$store.state.selectedCounty;
    },
    customer(): any {
      return this.$store.state.myCustomer;
    },
  },
  mounted() {
    // we need to wait for the store to get crap outta storage.
    setTimeout(() => {
      this.loaded = true;
    }, 500);
  },
  methods: {
    async checkForm() {
      this.submitting = true;
      const errorMsg = await this.$store.dispatch(
        "updateCounty",
        this.formData
      );
      if (errorMsg && errorMsg.length) {
        this.errorTxt = errorMsg;
        this.success = false;
      } else {
        this.errorTxt = "Update Successful";
        this.success = true;
      }
      this.submitting = false;
      setTimeout(() => {
        this.errorTxt = "";
      }, 2500);
    },
    async openModal() {
      const modal = await modalController.create({
        component: UpdateBillingModal,
      });
      modal.present();
    },
  },
  watch: {
    initFormData(val) {
      this.formData = val;
    },
  },
});
